import React, { useState, useEffect } from 'react';
import '../Styles/CardTorneo.css'; // Usa los mismos estilos, si los compartes
import { AgregarCardBoton } from '../../AddCard/Components/AddComponent';
import { Button, Form, Row, Col, Card, Container } from 'react-bootstrap';
import { FaTrash, FaEdit, FaUserPlus } from 'react-icons/fa';
import axios from 'axios';
import { FrmCrearEquipo } from './FrmEquipo';
import { BASE_URL } from './../../../config';
import teamImage from '../../../assets/equipo.jpg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const token = localStorage.getItem('token');

export const getAllEquipos = async () => {
    try {
        const response = await axios.get(`${BASE_URL}equipos`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data; // Retorna los datos de los equipos
    } catch (error) {
        console.error("Error al obtener los equipos:", error);
        throw error; // Lanza el error para manejarlo donde se use esta función
    }
};

/**
 * Elimina un equipo por su ID.
 * @param {number|string} idTeam - El ID del equipo a eliminar.
 * @returns {Promise<Object>} - La respuesta del servidor.
 * @throws Will throw an error if the deletion fails.
 */
export const deleteTeamById = async (idTeam) => {
    try {
        const response = await axios.delete(`${BASE_URL}equipos/${idTeam}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data; // Retorna la respuesta si la eliminación es exitosa
    } catch (error) {
        console.error(`Error al eliminar el equipo con ID ${idTeam}:`, error); // Mensaje de error mejorado
        throw error; // Lanza el error para manejarlo en otro lugar
    }
};

const CardEquipos = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [selectedEquipo, setSelectedEquipo] = useState(null);
    const [equipos, setEquipos] = useState([]);

    useEffect(() => {
        const fetchEquipos = async () => {
            try {
                const response = await axios.get(`${BASE_URL}equipos`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                setEquipos(response.data); // Guardar los equipos en el estado
            } catch (error) {
                console.error('Error al cargar los equipos:', error);
            }
        };

        fetchEquipos();
    }, []);

    const addEquiposArray = (addedEquipo) => {
        setEquipos(prevEquipos => [addedEquipo, ...prevEquipos]);
        toast.success('Equipo creado exitosamente');
        setSearchTerm('');
    };

    const updateEquiposArray = (updatedEquipo) => {
        setEquipos(prevEquipos =>
            prevEquipos.map(equipo =>
                equipo.id === updatedEquipo.id ? updatedEquipo : equipo
            )
        );
        toast.success('Equipo actualizado exitosamente');
        setSearchTerm('');
    };

    const filteredEquipos = equipos.filter(equipo => {
        if (searchTerm === '') {
            return true; // Mostrar todos los equipos si no hay término de búsqueda
        }
        return equipo.nombre.toLowerCase().includes(searchTerm.toLowerCase());
    });

    const handleOpenModal = (equipo = null) => {
        setSelectedEquipo(equipo);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedEquipo(null);
    };

    const handleDeleteEquipo = async (idEquipo) => {
        try {
            await deleteTeamById(idEquipo);
            setEquipos(prevEquipos => prevEquipos.filter(equipo => equipo.id !== idEquipo));
            toast.success('Equipo eliminado con éxito');
        } catch (error) {
            toast.error('Error al eliminar el equipo:', error);
        }
    };

    return (
        <Container className="py-4 justify-content-center">
            <Col md={12}>
                <Form.Control
                    type="text"
                    placeholder="Buscar equipos..."
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    className="search-input"
                />
            </Col>
            <Col md={6} className="text-end">
                <AgregarCardBoton image={teamImage} onOpenModal={() => handleOpenModal(null)} />
            </Col>

            <Row>
                {filteredEquipos.map((equipo) => (
                    <Col md={4} key={equipo.id} className="mb-4">
                        <Card className="h-100 shadow-sm">
                            <Card.Img variant="top" src={equipo.urlImagen} alt={equipo.nombre} />
                            <Card.Body>
                                <Card.Title>{equipo.nombre}</Card.Title>
                                <Card.Text>Deporte: {equipo.deporte}</Card.Text>
                            </Card.Body>
                            <Card.Footer>
                                <div className="d-flex justify-content-between">
                                    <Button
                                        variant="outline-primary"
                                        size="sm"
                                        className="custom-btn"
                                        onClick={() => handleOpenModal(equipo)}
                                    >
                                        <FaEdit /> <span className='text-button'>Actualizar</span>
                                    </Button>
                                    <Button
                                        variant="outline-danger"
                                        size="sm"
                                        className="custom-btn"
                                        onClick={() => handleDeleteEquipo(equipo.id)}
                                    >
                                        <FaTrash /> <span className='text-button'>Eliminar</span>
                                    </Button>
                                    <Button
                                        variant="outline-success"
                                        size="sm"
                                        className="custom-btn"
                                    >
                                        <FaUserPlus /> <span className='text-button'>Agregar Jugador</span>
                                    </Button>
                                </div>
                            </Card.Footer>
                        </Card>
                    </Col>
                ))}
            </Row>

            {/* Modal para agregar o actualizar equipo */}
            {showModal && (
                <FrmCrearEquipo
                    showModal={showModal}
                    handleCloseModal={handleCloseModal}
                    equipo={selectedEquipo ? selectedEquipo : null}
                    onAddEquipos={addEquiposArray}
                    onUpdateEquipos={updateEquiposArray}
                />
            )}
        </Container>
    );
};

export { CardEquipos };
